// @flow
import React from 'react';
import { Route } from 'react-router-dom';

import MainContent from 'bizom-mui/lib/MainContent';

import { SessionConsumer } from 'session';

import Verify from './screens/Verify';
import RemoteAuth from './screens/RemoteAuth';
import LoginForm from './components/LoginForm';
import LoginOTPRequestContainer from './containers/LoginOTPRequestContainer';

import * as paths from 'constants/paths';

const Login = () => (
  <MainContent maxWidth="sm" afterAppBar={false} fullWidth noPadding>
    <SessionConsumer>
      {({ loading, login, remoteLogin }) => (
        <LoginOTPRequestContainer>
          {({ isRequestingOTP, requestOTP }) => (
            <>
              <Route
                exact
                path={paths.LOGIN}
                render={() => (
                  <LoginForm loading={isRequestingOTP} onSubmit={requestOTP} />
                )}
              />
              <Route
                exact
                path={paths.LOGIN_REMOTE}
                render={() => (
                  <RemoteAuth loading={loading} remoteLogin={remoteLogin} />
                )}
              />
              <Route
                exact
                path={paths.LOGIN_VERIFY_USER}
                render={() => (
                  <Verify
                    resending={isRequestingOTP}
                    validating={loading}
                    onResendOTP={requestOTP}
                    onValidateOTP={login}
                  />
                )}
              />
            </>
          )}
        </LoginOTPRequestContainer>
      )}
    </SessionConsumer>
  </MainContent>
);

export default Login;
